export default __webpack_public_path__ + "static/patrik_antonius-062e1dbcc1abc19d4626ace4735b7e23.png";